// Store exports - all stores have been moved to their respective feature/entity directories

// Auth store moved to features/auth
export { useAuthStore } from '@/features/auth/model';
export {
  useUser,
  useToken,
  useIsAuthenticated,
  useIsInitialized,
  useAuthLoading,
  useLoginLoading,
  useRegisterLoading,
  useLogoutLoading,
  useHasError,
  useAuthError,
  useLoginError,
  useRegisterError,
  useUserProfile,
  useAuthState,
  useAuthActions,
  useIsEmailVerified,
  usePendingEmailVerification,
} from '@/features/auth/model';

// Subscription state — server bundle in TanStack Query (cacheKeys.subscriptions.active),
// client-only notifications in their own Zustand store. The fat Zustand
// `useSubscriptionStore` was removed in Wave A2.
export type { SubscriptionLimits } from '@/features/subscription/model';
export {
  useActiveSubscription,
  useSubscriptionNotificationsStore,
  useSubscription,
  usePlan,
  useUsage,
  useIsGuestMode,
  useEffectivePlan,
  useTokenBalance,
  useTokenBalanceInitialized,
  useSubscriptionLoading,
  useSubscriptionError,
  useSubscriptionNotifications,
  useIsDataLoaded,
  useRemainingTokens,
  useSubscriptionLimits,
  useSubscriptionStatus,
  useSubscriptionActions,
  useHasFeature,
  useIsSubscriptionActive,
  useCheckLimit,
  useNeedsUpgrade,
  usePlanTier,
} from '@/features/subscription/model';

// WebSocket stores moved to shared/api/websocket
export {
  useConnectionStore,
  useSubscriptionStore as useWebSocketSubscriptionStore,
  useMetricsStore,
  useWebSocketUIStore,
} from '@/shared/api/websocket';
